import { LazyImageStyle } from "@insite/mobius/LazyImage";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpoint from "@store/Framework/Common/Utilities/breakpoint";
import { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import { css } from "styled-components";

export interface BadgeProps {
    tagWrapper?: TagWrapperProps;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageWrapper?: InjectableCss;
}

export const badgeProps: BadgeProps = {
    tagWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    ${x => spacingStyles(x.theme.design.typography.spacing.base, null)}
                `,
            },
        },
    },
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
        `,
    },
    badgeText: {
        css: css`
            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.smaller};
                font-weight: ${theme.design.typography.weight.bold};

                ${breakpoint("xs", "only")} {
                    font-size: ${theme.design.typography.size.tiny};
                }
            `}
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 4em;
            height: auto;
            pointer-events: none;

            ${LazyImageStyle} {
                background-color: ${getColor("common.background")};
            }
        `,
    },
};
